import React, { useEffect, useState } from 'react';
import { useNavigate, useParams,useSearchParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/index.scss';
import Color from '@tool/color';
import Head from '../component/head';
import UpRate from './up-rate/index';
import TimeRate from './time-trend/index';
import CityRate from './city-rate/index';
import CategoryTypeRate from './category-type-rate/index';
import DetailCategoryRate from './detail-category-rate/index';
import LeaveRate from './leave-rate/index';
import LeaveRateTimeTrend from './leave-rate-time-trend/index';
import FreshSalary from './fresh-salary/index';
import CategoryFreshSalary from './category-fresh-salary/index';
import CityDifferent from './city-different/index';
import { newUrl } from '@/tool';
import moIndex from "../store";
interface IProps {}
interface IState {}

// 人力指标 - 涨薪率
const HumanIndicator = (props: IProps, state: IState) => {
  const navi = useNavigate();

  const {industry} = moIndex
  const [searchParams] = useSearchParams();
  const industryCode = searchParams.get('industryCode');
  const categoryName = searchParams.get('categoryName');
  // newUrl({title:'人力核心指标_人力指标',industryName: categoryName || industry.name,industryCode:industryCode|| industry.code},['title','industryName'])
  // const [pathId,setpathId] = useState("0")
  // let pathId = "0"
  const { id } = useParams();
  useEffect(() => {

    setTimeout(() => {
      if (id == '1') {
        // 涨薪率
        const distance1 = document.getElementById('indicator1')?.offsetTop || 325;
        window.scrollTo(0, distance1 + 60);
      } else if (id == '2') {
        // 离职率
        const distance2 = document.getElementById('indicator2')?.offsetTop || 325;
        window.scrollTo(0, distance2 + 60);
      } else if (id == '3') {
        // 应届生起薪
        const distance3 = document.getElementById('indicator3')?.offsetTop || 325;
        window.scrollTo(0, distance3 + 40);
      } else if (id == '4') {
        // 城市薪酬差异系数
        const distance4 = document.getElementById('indicator4')?.offsetTop || 325;
        window.scrollTo(0, distance4 + 60);
      }
      else { // 默认 id === '0'
        // 当id为0时，跳转到页面顶部
        window.scrollTo(0, 0);
      }
    }, 500);
    //
    return () => {};
  }, [searchParams]);

  useEffect(() => {
    // 只在 industry 变化且没有 URL 参数时更新 URL
    if (!industryCode) {
      newUrl({
        title:'人力核心指标_人力指标',
        industryName: industry.name,
        industryCode: industry.code,
      },
      ['title', 'industryName'], navi);
    }
  }, [industry, industryCode]);

  return (
    <section id="indicator1" className="human-indicator_10">
      <Head title="人力指标" bigTitle="涨薪率" />
      {/** 行业涨薪率 */}
      <UpRate />
      {/** 涨薪率时间趋势 */}
      <TimeRate />
      {/** 城市涨薪率 */}
      <CityRate />
      {/** 职能类型涨薪率 */}
      <CategoryTypeRate />
      {/** 细分职能涨薪率 */}
      <DetailCategoryRate />
      {/** 离职率 */}
      <LeaveRate />
      {/** 离职率时间趋势 */}
      <LeaveRateTimeTrend />
      {/** 行业应届生起薪 */}
      <FreshSalary key={id}/>
      {/** 职能应届生起薪 */}
      <CategoryFreshSalary />
      {/** 城市薪酬差异系数 */}
      <CityDifferent />
    </section>
  );
};

export default observer(HumanIndicator);
